import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import {
    createDOMElementIdFromString,
    getCombinedTextValueOfChildTextNodes,
    richTextParserOptions,
} from './richTextParserOptions';
import type { ParseRichTextParameter, TableOfContentsLinks } from '../types';

export const parseRichText = (richTextDocument: ParseRichTextParameter) =>
    documentToReactComponents(richTextDocument, richTextParserOptions);

export const parseRichContentToPlainText = (
    richTextDocument: ParseRichTextParameter
) => documentToPlainTextString(richTextDocument);

/**
 * Keeping things simple as we only need to support a single use case.
 *
 * If we ever get to a situation where we need to parse table of contents
 * differently in different components, this method and possibly parseRichText
 * method should be extended.
 */
export function parseTableOfContentsLinks(richText: ParseRichTextParameter) {
    return richText.content.reduce<TableOfContentsLinks[]>(
        (links, topLevelBlock) => {
            if (topLevelBlock.nodeType === 'heading-2') {
                const text = getCombinedTextValueOfChildTextNodes(
                    topLevelBlock.content
                );
                const id = createDOMElementIdFromString(text);
                return [
                    ...links,
                    {
                        text,
                        id,
                    },
                ];
            }
            return links;
        },
        []
    );
}
